import { VStack as ChakraVStack } from "@chakra-ui/react";

export const VStack = ChakraVStack;
